import { MultiPolygon } from 'src/common-services/types/geojson-types'
import { z } from 'zod'

export enum TrendsPeriod {
  WEEKLY = 'w',
  MONTHLY = 'm',
}

export type WeeklyDatesResponse = { periods: string[] }
export type TrendsDatesResponse = WeeklyDatesResponse

export type TrendsDatesRequest = { period: TrendsPeriod }

export type TrendsRequest = { venueId: string; start: string; end: string; period: TrendsPeriod }

export const trendsDatumSchema = z.object({
  date: z.string(),
  value: z.number(),
})

export type TrendsDatum = z.infer<typeof trendsDatumSchema>

export type TrendsResponseDatum = {
  date: string
  personCountSum: number
  dailyPersonCountP50: number
  average?: number
}
export type TrendsResponse = TrendsResponseDatum[]
export type AreaTrendsResponse = Array<TrendsResponseDatum & { venueCount: number; personCountAverage: number }>
export type AreaTrendsRequest = {
  shape: MultiPolygon
  start: string
  end: string
  period: TrendsPeriod
}

export type QuarterlyDatesResponse = { periods: QuarterPeriod[] }
export type PatternsHourDatesResponse = QuarterlyDatesResponse
export type PatternsWeekdayDatesResponse = QuarterlyDatesResponse
export type VisitLengthDatesResponse = QuarterlyDatesResponse
export type CaptureRateDatesResponse = QuarterlyDatesResponse

const patternsTimePeriodRequestSchema = z.object({
  start: z.string(),
  venueId: z.string(),
})
export type PatternsHourRequest = z.infer<typeof patternsTimePeriodRequestSchema>
export const patternsHourResponseSchema = z.array(
  z.object({
    hour: z.number(),
    peopleFractionVenue: z.number(),
    peopleFractionArea: z.number(),
  })
)
export type PatternsHourResponse = z.infer<typeof patternsHourResponseSchema>
export type AreaPatternsHourRequest = { shape: MultiPolygon; start: string }

export type PatternsWeekdayRequest = z.infer<typeof patternsTimePeriodRequestSchema>
export const patternsWeekdayDatesResponseSchema = z.array(
  z.object({
    dayOfWeek: z.number(),
    peopleFractionVenue: z.number(),
    peopleFractionArea: z.number(),
  })
)
export type PatternsWeekdayResponse = z.infer<typeof patternsWeekdayDatesResponseSchema>

export type AreaPatternsWeekdayRequest = AreaPatternsHourRequest

export type VisitLengthRequest = { venueId: string; start: string }
export type VisitLengthResponse = { visitLengthP25: number; visitLengthP50: number; visitLengthP75: number }

export type CaptureRateRequest = { venueId: string; start: string }
export type CaptureRateResponse = { captureRateP25: number; captureRateP50: number; captureRateP75: number }

export type ReturnRateDatesResponse = { periods: string[] }
export type ReturnRateRequest = { venueId: string; start: string; end: string }
export type ReturnRateResponse = Array<{ date: string; frac: number }>

export type DemographicDatesResponse = { periods: string[] }
export type DemographicRequest = { venueId: string; start: string }
export type DemographicResponse = Array<{ attribute: string; bucket: string; frac: number }>
export type AreaDemographicRequest = AreaPatternsHourRequest

export type QuarterPeriod = { quarter: string; start: string; end: string }
